<template>
  <div>
    <BaseCard :heading="$t('global.history')">
      <Timeline
        v-if="history.length"
        canDelete
        :data="history"
        @delete="onDelete"
      />
      <BaseText v-else-if="!history.length">
        {{ $t('global.no_results') }}
      </BaseText>
    </BaseCard>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from '@/axios';
import Timeline from '@/components/Timeline.vue';
import { modal } from '@/helpers/ui';

const { t } = useI18n();
const emit = defineEmits(['refresh']);
defineProps<{
  history: any[];
}>();

const customer = inject<any>('customer');

const onDelete = (timelineId: number) => {
  modal('confirmation', {
    type: 'delete',
    item: t('global.items.history'),
  }).then(() => {
    axios
      .delete(`timeline_items/${timelineId}?customer_id=${customer.value.id}`)
      .then(() => {
        emit('refresh');
      });
  });
};
</script>
